
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Membership from "../pages/membership/page";
import Programs from "../pages/programs/page";
import Advocacy from "../pages/advocacy/page";
import News from "../pages/news/page";
import Students from "../pages/students/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/membership",
    element: <Membership />,
  },
  {
    path: "/programs",
    element: <Programs />,
  },
  {
    path: "/advocacy",
    element: <Advocacy />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/students",
    element: <Students />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
